import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/36_card_back_yorkshire_terrier/36_card_back_yorkshire_terrier"
 * Contains 1 texture(s)
 */
export class CardsBacks36CardBackYorkshireTerrierAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/36_card_back_yorkshire_terrier/36_card_back_yorkshire_terrier';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '36_yorkshire_terrier.png'
    ] as const;
}
